import axios from 'axios'
const DEEPSEEK_API_URL = 'https://api.deepseek.com' // 实际的 DeepSeek API 地址
const DEEPSEEK_API_KEY = 'sk-4eae4145b4f44c6aa8145906a2fa3c01' // 替换为你的 DeepSeek API Key
// 创建 axios 实例
const deepseekClient = axios.create({
  baseURL: DEEPSEEK_API_URL,
  headers: {
    'Authorization': `Bearer ${DEEPSEEK_API_KEY}`,
    'Content-Type': 'application/json'
  }
})
/**
 * 调用 DeepSeek API 示例
 * @param {Object} data 请求参数
 * @returns {Promise} API 响应
 */
export const callDeepSeekAPI = async (data) => {
  try {
    const response = await deepseekClient.post('/chat/completions', data) // 替换为实际的 API 路径
    return response.data
  } catch (error) {
    console.error('DeepSeek API 调用失败:', error)
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/api/deepseek.js